<template>
  <b-container>
    <h1>Access denied</h1>
    <p>You do not have permission to perform this function.</p>
  </b-container>
</template>

<script>
export default {
  name: 'AccessDenied',
  mixins: [],
  data() {
    return {};
  },
  mounted() {
  },
  computed: {},
  methods: {},
  watch: {}
};
</script>

<style lang="scss"
       scoped>

</style>
